import { trimCharacter } from 'Lib/String';

const NamePartSeparator = '.';

const joinNameParts = (...args: Array<string | undefined>) => {
  return args
    .filter((arg) => !!arg)
    .map((n) => trimCharacter(n as string, '.'))
    .join(NamePartSeparator);
};

export { joinNameParts };
